export default "__VITE_ASSET__BZbpGbzU__"